export default {
  "language": "zh",
  "message":
    {
      "title": "混合收入住房奖金计算器",
      "zoningDistrict": "选择分区区域",
      "affordabilityLevel": "选择负担能力等级",
      "allThatApply": "选择所有适用的选项。",
      "springGardenS": "该项目位于春园街以南吗",
      "yes": "是的",
      "no": "没有",
      "affordability": {
        "lowIncome": "低收入",
        "moderateIncome": "收入适中",
      },
      "lotAreaSqft": "以平方英尺为单位输入地块面积",
      "buildingHeight": "输入建筑物高度",
      "totalUnits": "本項目推薦單位數量 ：",
      "unitsEarnedLow": "额外赚取的单位（低收入）：",
      "unitsEarnedMod": "额外赚取的单位（中等收入）：",
      "greenRoofBonus": "绿色屋顶奖励单位数量：",
      "modIncomePayment": "中等收入预计付款：",
      "lowIncomePayment": "低收入预估付款：",
      "requiredAffordableUnits": "必需的 MIHB 经济适用房：",
      "requiredMinAffordableUnits": "必需的 /MIN 经济适用房：",
      "totalRequiredAffordabilityUnits": "所需经济适用房总数：",
      "additionalFar": "额外获得的 FAR：",
      "totalFar": "FAR 总计：",
      "totalFloor": "允许的总建筑面积：",
      "overlay": {
        "fithDistrict": "该项目位于第五区覆盖区（/VDO）内。",
        "greenRoof": "该项目将获得绿色屋顶奖励。",
        "minMixed": "这个项目属于/MIN混合收入社区叠加层。 ",
        "todDevelopement": "该项目位于 /TOD Transit 导向开发叠加层中。",
      },
      "sFHA": [
        "特殊洪水灾害区域",
      ],
      "numberOfDwellingUnits": "基本分区下允许的住宅单元数量：",
      "about": "关于",
      "aboutTitle": "关于混合收入住房奖金",
      "aboutSubTitle": "如何使用计算器",
      "paragraphOne": "混合收入住房奖金适用于在其项目中增加经济适用房或向支持经济适用房的基金付款的开发商。 作为回报，该开发项目获得更多的 “右边” 建筑面积、高度和/或住宅单元。 开发者可以从两个奖励等级中进行选择。 中等收入水平的奖金较小，但其负担能力标准不那么严格，或者支付金额较低。 低收入水平是更大的奖金，但它有更严格的负担能力标准或更高的支付金额。",
      "paragraphTwo": {
        "text": "混合收入住房奖金计算器用于准确估计：",
        "bullets": [
          "允许的单位总数。",
          "您需要提供的经济适用房总数。",
          "使用混合收入住房奖金的开发项目将支付代替费用。",
        ],
      },
      "paragraphThree": {
        "text": "首先，请选择物业的基本分区区域并输入其地块区域。 您还应该选择任何适用的叠加区域。 你可以用",
        "link": {
          "text": "阿特拉斯",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "来查找此信息。",
      },
      "finalConfirmation": "这个计算器将用于概念性项目规划。 如果计算器与《费城分区法》之间存在差异，则以《费城分区法》为准。 费城城市规划委员会工作人员将在分区许可证审查期间对单元、所需经济适用单元数量和/或费用替代金额进行最终确认。",
      "resources": "资源",
      "code1": {
        "link": {
          "text": "费城法典 — 14-702 (7) — 混合收入住房奖金",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "费城法典 — 14-533 — 混合收入社区叠加区",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "混合收入住房奖金情况说明书",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};